/**
 * Version checking constants
 */
export const VERSION_LOCAL_STORAGE_KEY = "@voltacall/version/build";
export const VERSION_POLLING_INTERVAL_MS = 30_000; // 30 seconds
export const AUTO_UPDATE_HOUR = 6; // 6:00 AM
